/* global PAYPAL */
import React from 'react';
import { Button } from '@paypalcorp/pp-react';
import { clientLogger } from '../../../lib/logger';
import PropTypes from 'prop-types';
import { parseData } from '../../../lib/helpers';

const SurveyButton = ({ fptiClick, toolTileProps, content }) => {
  const { survey } = content;
  let buttonItems = {};
  if (survey) {
    buttonItems = parseData(survey)[0];
  }
  if (typeof buttonItems === 'undefined') {
    return null;
  }

  const { name, id, icon } = buttonItems;

  if (!name || !id || !icon) {
    return null;
  }

  const reloadQualtrics = () => {
    fptiClick({ fptiLink: 'survey_feedback_button' });
    if (
      typeof window !== 'undefined' &&
      typeof PAYPAL !== 'undefined' &&
      PAYPAL.analytics
    ) {
      const obj = {
        page: window.feedback?.page,
        rsta: toolTileProps?.app?.context?.locale?.locale
      };
      window.laDataLayer = window.laDataLayer || {};
      window.laDataLayer = { ...obj, ...window.laDataLayer };
      try {
        PAYPAL.analytics.reloadQualtrics(id);
      } catch (err) {
        clientLogger.warn(` qualtrics function not loaded : ${err}`);
      }
    }
  };
  return (
    <div className="survey-button-container">
      <Button className="survey-button" onClick={reloadQualtrics} href="#">
        <img className="survey-icon lazyload" alt="survey" data-src={icon} />
        <span className="survey-title">{name}</span>
      </Button>
    </div>
  );
};

SurveyButton.propTypes = {
  fptiClick: PropTypes.func.isRequired,
  toolTileProps: PropTypes.object,
  content: PropTypes.object
};
export default SurveyButton;
